<div class="row">
  <div class="col-md-6 col-xl-4 content-recipe-product mb-4" *ngFor="let product of products">
    <div class="rounded d-flex flex-column h-100">
      <div>
        <img [src]="product.image" class="w-100 image-recipe" alt="">
      </div>
      <div class="recipe-description h-100 d-flex flex-column sp-between">
        <div class="pb-5">
          <div class="mb-2 content-title text-ellipsis">
            <p class="fs-5 fw-extrabold ellipsis-text mb-0">{{product.title}}</p>
          </div>
          <div>
            <span class="fw-regular">{{product.descripcion}}</span>
          </div>
          <br>
          <div class="d-flex flex-column">
            <div *ngFor="let bullet of product.bullets.slice(0, 1) " class="d-flex al-center">
              <img [src]="bullet.icon" class="me-3" alt="">
              <span class="fw-regular">{{bullet.name}}</span>
            </div>
          </div>
        </div>
        <div class="w-100 d-flex sp-center">
          <div class="action bg-blue d-flex al-center sp-center pointer w-100" (click)="showDetail(product.id)">
            <span class="text-white fw-medium fs-5">{{product.action}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>